import { ResultType } from 'src/types/types.ts';

export const RESULT_TYPES: ResultType[] = [
  {
    name: 'Customer-Blind',
    range: '1,0 – 1,9',
    min: 1.0,
    max: 1.999,
    tone: 'red',
    short:
      'Kundenzentrierung spielt keine zentrale Rolle in der Art, wie die Organisation denkt, entscheidet und handelt. Der Kundenfokus ist minimal ausgeprägt.'
  },
  {
    name: 'Customer-Curious',
    range: '2,0 – 2,9',
    min: 2.0,
    max: 2.999,
    tone: 'darkorange',
    short:
      'Kundenzentrierung ist erkannt, wird aber noch nicht konsistent in der Art gelebt, wie die Organisation denkt, entscheidet und handelt. Es gibt Ansätze, denen aber die durchgängige Verbindlichkeit fehlt.'
  },
  {
    name: 'Customer-Focused',
    range: '3,0 – 3,9',
    min: 3.0,
    max: 3.999,
    tone: 'orange',
    short:
      'Kundenzentrierung beginnt, die Art zu prägen, wie die Organisation denkt, entscheidet und handelt – teilweise sichtbar, teilweise noch lückenhaft. Die Aktivitäten zeigen erste Mehrwerte, aber noch keine konsistente Wirkung.'
  },
  {
    name: 'Customer-Driven',
    range: '4,0 – 4,4',
    min: 4.0,
    max: 4.499,
    tone: 'lime',
    short:
      'Kundenzentrierung prägt deutlich die Art, wie die Organisation denkt, entscheidet und handelt. Sie ist größtenteils gelebte Arbeitsweise – mit nur einzelnen, noch nicht vollständig umgesetzten Bereichen.'
  },
  {
    name: 'Customer Champion',
    range: '4,5 – 5,0',
    min: 4.5,
    max: 5.0,
    tone: 'green',
    short:
      'Kundenzentrierung ist die Art, wie die Organisation denkt, entscheidet und handelt – jeden Tag, auf jeder Ebene. Sie ist gelebte Realität und zentraler Erfolgsfaktor.'
  }
];
